import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  STANDARD_COST_PRICE_GET_REQUEST,
  STANDARD_COST_PRICE_GET_SUCCESS,
  STANDARD_COST_PRICE_GET_FAILURE,
  STANDARD_COST_PRICE_GET_RESET,
  STANDARD_COST_PRICE_CREATE_REQUEST,
  STANDARD_COST_PRICE_CREATE_SUCCESS,
  STANDARD_COST_PRICE_CREATE_FAILURE,
  STANDARD_COST_PRICE_CREATE_RESET,
  STANDARD_COST_PRICE_EDIT_REQUEST,
  STANDARD_COST_PRICE_EDIT_SUCCESS,
  STANDARD_COST_PRICE_EDIT_FAILURE,
  STANDARD_COST_PRICE_EDIT_RESET,
  STANDARD_COST_PRICE_EXPORT_REQUEST,
  STANDARD_COST_PRICE_EXPORT_SUCCESS,
  STANDARD_COST_PRICE_EXPORT_FAILURE,
  STANDARD_COST_PRICE_EXPORT_RESET,
} from './../../constants'

export function createStandardCostPrice(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/standard-cost-prices`,
      method: 'POST',
      types: [
        STANDARD_COST_PRICE_CREATE_REQUEST,
        STANDARD_COST_PRICE_CREATE_SUCCESS,
        STANDARD_COST_PRICE_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function getStandardCostPrice(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/standard-cost-prices`,
      method: 'GET',
      types: [
        STANDARD_COST_PRICE_GET_REQUEST,
        STANDARD_COST_PRICE_GET_SUCCESS,
        STANDARD_COST_PRICE_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editStandardCostPrice(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/standard-cost-prices/${id}`,
      method: 'PUT',
      types: [
        STANDARD_COST_PRICE_EDIT_REQUEST,
        STANDARD_COST_PRICE_EDIT_SUCCESS,
        STANDARD_COST_PRICE_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function exportStandardCostPrice(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/standard-cost-prices/exports`,
      method: 'GET',
      types: [
        STANDARD_COST_PRICE_EXPORT_REQUEST,
        STANDARD_COST_PRICE_EXPORT_SUCCESS,
        STANDARD_COST_PRICE_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function resetGetStandardCostPrice() {
  return {
    type: STANDARD_COST_PRICE_GET_RESET,
  }
}
export function resetCreateStandardCostPrice() {
  return {
    type: STANDARD_COST_PRICE_CREATE_RESET,
  }
}
export function resetEditStandardCostPrice() {
  return {
    type: STANDARD_COST_PRICE_EDIT_RESET,
  }
}
export function resetExportStandardCostPrice() {
  return {
    type: STANDARD_COST_PRICE_EXPORT_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/actions/standard-cost-price/standard-cost-price-action.js